import React from 'react';
import BtnSubmit from '../../../../../Shared/Buttons/BtnSubmit';

export default function PopupError(props) {
    const description = props.isDisplayWhatsApp ? 'לצערנו לא הצלחנו להסיר את השירות המבוקש. אפשר לנסות שוב או להסיר בעזרת נציג ב-WhatsApp' : 'לצערנו לא הצלחנו להסיר את השירות המבוקש.';
    return (
        <div className='remove-service-popup'>
            <div className='popup-title'> נראה שמשהו השתבש </div>
            <div className='popup-description'>{description}</div>
            <div  className={`popup-button-wrapper ${props.isDisplayWhatsApp ? 'two-buttons' : ''}`}>
                <BtnSubmit text='נסיון נוסף' onclick={props.onRetryToRemove} formid='service-details-popup' />
                {props.isDisplayWhatsApp && <BtnSubmit text='צט עם נציג' onclick={props.onOpenChat} formid='service-details-popup' />}
            </div>
        </div>
    );
};

